// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_FiscalConfigSaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for the subaccounts fiscal_config save endpoint.
 *
 * franchise_id is intentionally NOT a body field — it lives in the URL
 * path and is verified against the caller's permitted franchises in the
 * controller. Allowing it in the body would let a caller target a
 * different franchise than the one in the path.
 */
import { registerContract } from './validate'

export interface Invoice_FiscalConfigSaveInput {
config?: string
}

registerContract('Invoice_FiscalConfigSaveInput', {
  config: { type: 'string',  required: false },
})
